import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useQualityReqForm } from './hooks/useQualityReqForm';

const { TextArea } = Input;

const P111HForm: React.FC = () => {
  const {
    mode, isEditing, loading, records, current, currentIdx,
    code, setCode, desc, setDesc,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete, quickSearch,
  } = useQualityReqForm();

  const [searchText, setSearchText] = useState('');
  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${current.f11h_01}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: doDelete,
    });
  };
  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          品質要求設定 (pw111hf1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && quickSearch(searchText.trim())}
            disabled={isEditing} style={{ width: 150 }} maxLength={2} />
          <Button onClick={() => searchText.trim() && quickSearch(searchText.trim())} disabled={isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || !records.length}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || !records.length}>&gt;|</Button>
        </div>
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">品質要求代號 (F11H_01)</label>
            <Input value={code} onChange={e => setCode(e.target.value)} maxLength={2}
              disabled={mode !== 'add'} style={{ width: 100 }} placeholder="2碼" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">品質要求說明 (F11H_11)</label>
            <TextArea value={desc} onChange={e => setDesc(e.target.value)}
              disabled={!isEditing} rows={6} style={{ width: 500 }} />
          </div>
        </div>
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立者: {current.f11h_91} | 建立日期: {current.f11h_92 || '-'} | 修改者: {current.f11h_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P111HForm;
